export default {
    account_overview_title: 'Account',
    account_overview_actions: 'Actions',
    account_overview_username: 'Username',
    account_overview_opened_at: 'Opened at',
    account_overview_status: 'Status',
    account_overview_package: 'Package',
    account_overview_devices: 'Devices',
    account_overview_brand: 'Brand',
    account_overview_dealer: 'Dealer',
    account_overview_crm: 'Salesforce Id',
    account_overview_activities: 'Activities',
    account_overview_keysfobs: 'DriverID Tags',
    account_overview_user: 'Users',

    account_overview_edit_account: 'Edit Account',
    account_overview_reset_account_password: 'Change Password',
    account_overview_change_account_status: 'Change Status',
    account_overview_change_account_dealer: 'Change Dealer',
    account_overview_import_and_assign: 'Import and Assign',
    account_overview_device_models: 'Device Models',
    account_overview_part_numbers: 'Part Numbers',
    account_overview_unit_types: 'Unit Types',
    account_overview_active_devices: 'Active Devices',
    account_overview_system_alert_logs: 'System Alert Logs',
    account_overview_scheduled_reports: 'Scheduled Reports',
    account_overview_email: 'Email',
    account_overview_export_logs: 'Export Logs',
    account_overview_terms_conditions: 'Verify Terms and Conditions',
    account_overview_scheduled_actions: 'Schedule Actions',
    account_overview_change_username: 'Change Username',
    account_overview_promiles_request: 'Promiles Request',
    account_overview_integrations: 'Integrations',
    account_overview_warnings: 'Warnings',
    account_overview_reset_account_email: 'Change Email',
    account_overview_registration_status: 'Registration Status',
    account_overview_resend_invite: 'Resend Invite',
    account_overview_credentials: 'Credentials',
    account_overview_syncZonar: 'Sync Zonar',
    account_overview_readonly: 'Read Only',
    account_overview_edge_tensor: 'AI Video Reviews',
    account_overview_api_keys: 'API Keys',
};

